import { FC } from 'react';
import JobProgressTabs from '~src/components/organisms/JobProgressTabs';

// interface DashboardProps {}

const Dashboard: FC = () => <JobProgressTabs />;

export default Dashboard;
